export default function PageHeader({
  title,
  description,
  actions,
  icon: Icon,
  iconClassName = "text-primary",
  children,
}) {
  return (
    <div className="aa-glass-card mb-3 flex flex-col gap-3 rounded-xl px-4 py-3 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <h1 className="aa-page-title flex items-center gap-2">
          {Icon && <Icon className={`h-5 w-5 ${iconClassName}`} />}
          <span className="aa-gradient-text">{title}</span>
        </h1>
        {description && <p className="mt-1 text-sm text-foreground/70">{description}</p>}
      </div>
      {(actions || children) && <div className="flex flex-wrap gap-2">{actions ?? children}</div>}
    </div>
  );
}
